import { render, staticRenderFns } from "./ResumeFolderController.vue?vue&type=template&id=eb833e6c"
import script from "./ResumeFolderController.vue?vue&type=script&lang=js"
export * from "./ResumeFolderController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports